import { combineReducers } from 'redux';

import departureCityReducer from './departure-city/departureCity.reducer';
import departureDateReducer from './departure-date/departureDate.reducer';
import durationReducer from './duration/duration.reducer';

export default combineReducers({
  departureCity: departureCityReducer,
  departureDate: departureDateReducer,
  duration: durationReducer,
});
